import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { useAppContext } from 'providers/AppProvider';
import { TooltipComponent } from 'echarts/components';
import { GaugeChart } from 'echarts/charts';
import { CallbackDataParams } from 'echarts/types/dist/shared';
import { handleTooltipPosition } from 'helpers/echart-utils';
import { OrderStatsData } from 'api/dashboard/_request';

echarts.use([TooltipComponent, GaugeChart]);

const getChartOptions = (
  getThemeColor: (name: string) => string,
  totalSpent: number,
  spentTarget: number
) => ({
  tooltip: {
    trigger: 'item',
    formatter: (params: CallbackDataParams) => {
      return `<strong>${params.seriesName}:</strong> ₹${params.value}`;
    },
    position: handleTooltipPosition
  },
  series: [
    {
      type: 'gauge',
      name: 'Total Spent',
      startAngle: 180,
      endAngle: 0,
      min: 0,
      max: spentTarget,
      progress: {
        show: true,
        width: 12,
        roundCap: true
      },
      axisLine: {
        lineStyle: {
          width: 12,
          color: [[1, getThemeColor('primary-bg-subtle')]]
        }
      },
      itemStyle: {
        color: getThemeColor('primary')
      },
      pointer: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: { show: false },
      detail: {
        show: true,
        formatter: () => `SAR ${totalSpent} / ${spentTarget}`,
        fontSize: 14,
        color: getThemeColor('body-color'),
        offsetCenter: [0, '40%']
      },
      data: [
        {
          value: totalSpent
        }
      ]
    }
  ]
});

type EcomProductSpentChartProps = {
  data: OrderStatsData;
  range: 'today' | 'week' | 'month' | 'year';
};

const EcomProductSpentChart = ({ data }: EcomProductSpentChartProps) => {
  const { getThemeColor } = useAppContext();

  const spentTarget = 50000; // adjust based on business logic
  const options = getChartOptions(getThemeColor, data.totalSpent, spentTarget);

  return (
    <ReactEChartsCore
      echarts={echarts}
      option={options}
      style={{ height: '100%', width: '100%' }}
    />
  );
};

export default EcomProductSpentChart;
